import { SKETCH_OBJECT_CATEGORY_LABELS, SketchObjectCategory } from '../../potree/sketchObjects/types';
import type { ObjectLibraryFieldsFragment } from '../../types/graphqlTypes';

export interface LibraryCategoryOption {
  id: string;
  label: string;
  builtin: boolean;
}

/** Built-in categories first (translation keys), then the organisation's own (plain labels). */
export function libraryCategoryOptions(config: ObjectLibraryFieldsFragment['config'] | undefined): LibraryCategoryOption[] {
  return [
    ...Object.values(SketchObjectCategory).map((id) => ({ id, label: SKETCH_OBJECT_CATEGORY_LABELS[id], builtin: true })),
    ...[...(config?.categories ?? [])].sort((a, b) => a.order - b.order).map((c) => ({ id: c.id, label: c.label, builtin: false })),
  ];
}

/** The config as the update mutation takes it (drops __typename). */
export function toConfigInput(config: ObjectLibraryFieldsFragment['config']) {
  return {
    hiddenTypeIds: [...config.hiddenTypeIds],
    categories: config.categories.map(({ id, label, order }) => ({ id, label, order })),
    typeOrder: config.typeOrder.map(({ typeId, categoryId, order }) => ({ typeId, categoryId, order })),
  };
}

export type ObjectLibraryConfigInputValue = ReturnType<typeof toConfigInput>;
